var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.74,191.66c.74-5.44-6.93-9.91-12.69-10.38-2.75-.22-5.61.2-8.21-.71-5.65-2-7.9-9.25-13.41-11.58-4.11-1.73-8.85-.19-12.84,1.82s-7.94,4.54-12.4,4.82c-3.88.25-8.09-1.19-11.48.71-2.53,1.41-3.85,4.32-6.18,6s-5.26,2-8.09,2.19-5.76.19-8.33,1.37-4.71,3.9-4.17,6.68Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.8,102.42c.59-4.28-5.45-7.8-10-8.17-2.16-.17-4.41.16-6.46-.55-4.44-1.55-6.21-7.29-10.54-9.12-3.24-1.36-7-.15-10.11,1.43s-6.24,3.57-9.75,3.8c-3,.19-6.37-.94-9,.55-2,1.11-3,3.41-4.86,4.76s-4.14,1.6-6.36,1.72-4.53.15-6.56,1.07-3.7,3.08-3.28,5.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.39,74.06c1-7.15-9.12-13-16.71-13.65-3.61-.29-7.37.26-10.8-.94-7.43-2.59-10.4-12.18-17.65-15.24-5.42-2.29-11.66-.25-16.91,2.39S97.87,52.59,92,53c-5.1.33-10.65-1.57-15.11.93-3.33,1.86-5.08,5.69-8.14,8s-6.92,2.69-10.64,2.89-7.58.24-11,1.79-6.19,5.14-5.49,8.8Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.88,338.74s-7.5-2.43-11,14.87-4,26.86-4,26.86-1.16,3.75-3.92,2.28-7.38-6.54-10.79-4.45-3.62,6.82-1.14,12.92,7.44,19.68,7.88,20.91.23,3.21-1.81,2.51-14.93-8.94-18.48-2.58,6.17,22.22,7.2,24,.88,2.66.11,3.38-4.84-2.46-8.61-4.65-8.51-4.08-10.25-.24,1,17,19.16,34.6l8.94,7.6L75.29,473c23.4-9.54,30.88-20.71,30.7-24.92s-5.28-4.24-9.6-3.61-9.28,2.05-9.72,1.09-.24-1.85,1.37-3.1,16.55-12.33,15.64-19.55-16-4.39-18.11-4.51-1.59-2.05-.73-3S95.37,403.63,100,398.9s6.25-9.07,3.77-12.41-8.56-.24-11.67.09S89.28,383,89.28,383s3.1-9.05,6.31-26.42-4.86-17.89-4.86-17.89",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.88,479.26c2.41-12.74,7.06-35.32,10.95-54.73s7.4-37,9.87-49.69c1.23-6.36,2.22-11.51,2.91-15.08.34-1.77.61-3.15.79-4.1.09-.46.17-.81.22-1.07s.08-.36.08-.36,0,.13,0,.37-.1.61-.18,1.07c-.17,1-.41,2.34-.72,4.11-.64,3.57-1.59,8.73-2.8,15.11-2.4,12.74-5.87,30.32-9.76,49.72s-8.59,42-11,54.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.31,385.64a4.37,4.37,0,0,1,.5.69c.3.46.72,1.12,1.22,2,1,1.66,2.36,4,3.79,6.6l3.65,6.68,1.12,2a3.85,3.85,0,0,1,.38.76,4.1,4.1,0,0,1-.51-.69c-.3-.45-.71-1.12-1.21-2-1-1.68-2.31-4-3.75-6.63s-2.7-4.88-3.69-6.65l-1.13-2A3.41,3.41,0,0,1,67.31,385.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.06,404.26c0-.09,4.64-3.06,10.49-6.65s10.62-6.43,10.67-6.34-4.64,3.06-10.48,6.65S79.11,404.35,79.06,404.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.74,433.79a3.51,3.51,0,0,1,.82-.27l2.27-.63c1.92-.52,4.56-1.26,7.45-2.19s5.48-1.83,7.34-2.52l2.22-.8a4.14,4.14,0,0,1,.82-.26,3.39,3.39,0,0,1-.77.39c-.51.23-1.25.55-2.17.92-1.85.74-4.43,1.7-7.33,2.62s-5.56,1.63-7.49,2.09c-1,.23-1.76.41-2.3.51A4.72,4.72,0,0,1,71.74,433.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4,419.29a2.92,2.92,0,0,1,.62.51l1.59,1.48c1.33,1.27,3.16,3,5.15,5s3.79,3.76,5.08,5.08l1.51,1.56a3.25,3.25,0,0,1,.52.62,4,4,0,0,1-.62-.51l-1.59-1.49c-1.33-1.27-3.16-3-5.15-5s-3.79-3.77-5.08-5.08l-1.51-1.57A3.44,3.44,0,0,1,57.4,419.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.63,444.53a6.47,6.47,0,0,1,.78.66l2.05,1.9c1.71,1.61,4.07,3.86,6.65,6.36s4.91,4.78,6.58,6.44l2,2a5.13,5.13,0,0,1,.69.76,5,5,0,0,1-.78-.66c-.54-.49-1.22-1.13-2.05-1.9-1.72-1.61-4.07-3.86-6.65-6.36s-4.91-4.77-6.58-6.43l-2-2A4.89,4.89,0,0,1,47.63,444.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,462.07a8.72,8.72,0,0,1,1-.37l2.85-.89c2.41-.76,5.73-1.81,9.36-3.08s6.89-2.5,9.24-3.41l2.79-1.07a5.32,5.32,0,0,1,1-.35,6.87,6.87,0,0,1-1,.48c-.64.29-1.58.7-2.74,1.18-2.33,1-5.58,2.25-9.22,3.51s-7,2.29-9.41,3c-1.21.34-2.2.61-2.88.78A7.1,7.1,0,0,1,66,462.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.8,409a15.14,15.14,0,0,1,10.91,4.62,26.66,26.66,0,0,1,6.14,10.41c2.58,7.42,2,16.45.37,24.14-8.41-2.33-14.1-10.71-16.72-15.14-4.14-7-7.37-22.17-.7-24",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.68,456.54a12.94,12.94,0,0,1-1.54-12.88,17.14,17.14,0,0,1,9.7-9c2-.76,4.26-1.19,6.08-.15a5.52,5.52,0,0,1,2.5,5,11.3,11.3,0,0,1-2,5.47c-3.6,5.68-8.12,10.53-14.77,11.57",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.47,476.19a24.49,24.49,0,0,1-1.41-5,23.93,23.93,0,0,1-.52-5.66,53.75,53.75,0,0,1,.45-6.91,26,26,0,0,1,4.63-11.68,19.66,19.66,0,0,1,2.62-2.8c.7-.56,1.12-.84,1.15-.79s-1.46,1.35-3.26,4a27.67,27.67,0,0,0-4.27,11.44,62.22,62.22,0,0,0-.51,6.8,26.86,26.86,0,0,0,.32,5.53A38.62,38.62,0,0,1,328.47,476.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.28,420.38a14.1,14.1,0,0,1,1.37,2.24c.83,1.48,2,3.62,3.42,6.29,2.84,5.33,6.69,12.74,10.74,21s7.5,15.9,9.88,21.45c1.19,2.78,2.13,5,2.75,6.61a16.16,16.16,0,0,1,.88,2.48,14.83,14.83,0,0,1-1.2-2.34c-.77-1.68-1.78-3.86-3-6.49-2.52-5.49-6.06-13-10.1-21.33s-7.75-15.58-10.5-21.13c-1.29-2.6-2.36-4.75-3.17-6.41A16,16,0,0,1,301.28,420.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,463.53a30.25,30.25,0,0,0-26-9.35c-2.41.33-5.18,1.34-5.79,3.71s1.36,4.59,3.35,6a25.8,25.8,0,0,0,28.63.27",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.2,459.13a4.31,4.31,0,0,1,1.38-.15c.88-.05,2.17,0,3.76,0a34,34,0,0,1,12.14,2.62,21.32,21.32,0,0,1,5.75,3.81,20.93,20.93,0,0,1,5.14,7.81,4,4,0,0,1,.39,1.33c-.16.07-.85-1.78-2.55-4.4a21.9,21.9,0,0,0-3.53-4.14,22.23,22.23,0,0,0-5.56-3.61,38.27,38.27,0,0,0-11.83-2.8A45.72,45.72,0,0,1,299.2,459.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.5 199.3 61.21 173.97 48.87 181.84 29.93 165.56 47.1 190.61 59.6 182.58 73.5 199.3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.82 206.25 52.71 197.9 49.43 207.24 32.55 206.48 52.15 212.65 55.45 203.15 69.82 206.25",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.49,452.87a2.89,2.89,0,0,1-.63-.13c-.41-.1-1-.3-1.78-.47a42.18,42.18,0,0,0-16.64-.65,41,41,0,0,0-30.82,24.67c-.33.73-.51,1.32-.68,1.71a4.35,4.35,0,0,1-.26.59,2.91,2.91,0,0,1,.16-.62c.13-.4.29-1,.59-1.75a36.9,36.9,0,0,1,3-6.12,39.86,39.86,0,0,1,38.05-19.26,36.15,36.15,0,0,1,6.69,1.24c.78.19,1.36.43,1.76.56A3.39,3.39,0,0,1,401.49,452.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.05,451.33a14.88,14.88,0,0,0-2.79,15.07c.39,1,1.1,2.08,2.17,2.09s1.85-1.21,2.22-2.29a17.49,17.49,0,0,0-1.25-13.85,20,20,0,0,0,7.32,9c1.24.83,3,1.51,4.16.62s1.05-2.64.57-4a11.79,11.79,0,0,0-11.75-7.57A11.07,11.07,0,0,0,409.56,444c.68-1.59.75-3.84-.78-4.64a3.63,3.63,0,0,0-3,.23,14.09,14.09,0,0,0-7.87,8.8A12.4,12.4,0,0,0,395.61,435c-1.07-1.11-2.6-2.06-4.08-1.63-1.86.54-2.48,2.89-2.43,4.83a16.23,16.23,0,0,0,6.52,12.42,9.2,9.2,0,0,0-8.55-.74c-1.8.77-3.48,2.75-2.68,4.53s3.14,1.86,5,1.52a23,23,0,0,0,9.28-4",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.63,459.21a30.73,30.73,0,0,0,23.24,11.46c-.15-2-1.7-3.5-3.26-4.69A31.69,31.69,0,0,0,364,459.54",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.12,461.92a47.66,47.66,0,0,0,.95-5.79,49.48,49.48,0,0,0-.28-5.86,15.54,15.54,0,0,1-.67,11.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.61,457.74A23.8,23.8,0,0,0,401.7,454c-1.92-1.81-3.89-2.79-3.8-2.94a10.22,10.22,0,0,1,4.16,2.56A7.87,7.87,0,0,1,404.61,457.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.24,444.64a8.55,8.55,0,0,1-2.35,4,7.28,7.28,0,0,1-4,2.43,21.37,21.37,0,0,0,3.61-2.79A44.7,44.7,0,0,0,404.24,444.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,448.82a1.81,1.81,0,0,1,1.5,3A5.1,5.1,0,0,0,398,451a7.55,7.55,0,0,0,0-2.18",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.68,438.21a6.3,6.3,0,0,1,1.42,1.56,18.74,18.74,0,0,1,3.55,9.43,5.81,5.81,0,0,1,0,2.1,35.31,35.31,0,0,0-1.57-6.88A37,37,0,0,0,392.68,438.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.34,440.82a8,8,0,0,1,5.73,2.5,14.21,14.21,0,0,1,3.17,5.53c1.31,3.93.95,8.69,0,12.74-4.42-1.29-7.38-5.74-8.73-8.09-2.14-3.72-3.76-11.74-.22-12.68",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.81,466.05a6.82,6.82,0,0,1-.73-6.8,9,9,0,0,1,5.17-4.7,3.8,3.8,0,0,1,3.21,0,2.9,2.9,0,0,1,1.28,2.65A5.86,5.86,0,0,1,61.67,460c-1.93,3-4.35,5.5-7.86,6",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1,479.38a5.11,5.11,0,0,1-.24-.82c-.15-.58-.35-1.34-.58-2.25a24,24,0,0,1-1-7.62,14.74,14.74,0,0,1,2.41-7.27,10.59,10.59,0,0,1,1.54-1.76c.2-.19.38-.31.49-.4s.18-.13.19-.12a15.41,15.41,0,0,0-2,2.4,15.16,15.16,0,0,0-2.29,7.17,26.08,26.08,0,0,0,.85,7.55c.22,1,.39,1.74.49,2.28A4,4,0,0,1,55.1,479.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1,446.82a1.28,1.28,0,0,1,.2.31l.5.94c.44.82,1.05,2,1.79,3.48,1.49,2.95,3.49,7.05,5.6,11.63S52.11,472,53.38,475c.63,1.52,1.13,2.76,1.47,3.62.16.41.28.74.38,1a1.48,1.48,0,0,1,.12.36,1.71,1.71,0,0,1-.17-.33c-.12-.25-.26-.58-.44-1-.38-.89-.91-2.1-1.56-3.59-1.32-3-3.16-7.2-5.26-11.78s-4.08-8.69-5.52-11.66c-.7-1.46-1.28-2.65-1.7-3.52q-.29-.58-.45-1A2.94,2.94,0,0,1,40.1,446.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.43,470.86a16,16,0,0,0-12.81-6.92c-1.29,0-2.81.3-3.32,1.48s.35,2.5,1.28,3.39A13.63,13.63,0,0,0,49.5,471.2",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.77,467.25a3.94,3.94,0,0,1,.81,0,6.65,6.65,0,0,1,.94,0c.36.05.78.06,1.24.16a14.06,14.06,0,0,1,1.48.31,15.67,15.67,0,0,1,1.66.52,17.85,17.85,0,0,1,3.55,1.82,17,17,0,0,1,3,2.63,15.26,15.26,0,0,1,1.08,1.36,12.29,12.29,0,0,1,.82,1.28,12.1,12.1,0,0,1,.58,1.11,6.94,6.94,0,0,1,.37.86,3.74,3.74,0,0,1,.26.77c-.06,0-.44-1.06-1.39-2.63-.25-.39-.51-.82-.84-1.24a15.5,15.5,0,0,0-1.09-1.32,17.28,17.28,0,0,0-3-2.57,17.79,17.79,0,0,0-3.47-1.81,16.32,16.32,0,0,0-1.63-.54c-.52-.16-1-.25-1.46-.35C39.92,467.3,38.77,467.31,38.77,467.25Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--404-error--inject-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "323.77 480.07 350.95 480.07 389.94 291.29 363.88 285.9 323.77 480.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.83 420.26 276.63 386.34 271.98 382.17 289.34 324.83 296.96 325.33 285.21 319.07 291.93 285.56 456.13 319.48 460.79 323.66 453.98 356.62 440.97 356.86 448.13 358.23 452.78 362.4 440.83 420.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.18 416.09 271.98 382.17 284.69 320.65 292.31 321.15 285.95 314.54 291.93 285.56 456.13 319.48 449.32 352.44 436.32 352.68 448.13 358.23 436.18 416.09",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.83,352.34s-.13,0-.39,0l-1.15-.08-4.42-.36-3.19-.28-3.79-.45c-2.71-.34-5.82-.66-9.21-1.22l-5.35-.81c-1.86-.29-3.78-.67-5.77-1-4-.68-8.23-1.57-12.69-2.47-8.91-1.89-18.66-4.18-28.84-6.77-20.35-5.24-38.69-10.28-52.07-13.55-3.33-.85-6.37-1.54-9-2.18s-5-1.16-6.84-1.57l-4.32-1-1.12-.27a2.25,2.25,0,0,1-.38-.12,1.78,1.78,0,0,1,.39.06l1.14.21,4.34.87c1.89.38,4.2.87,6.86,1.48s5.71,1.27,9.06,2.09c13.4,3.16,31.77,8.14,52.11,13.37,10.18,2.59,19.91,4.9,28.8,6.82,4.46.91,8.68,1.82,12.67,2.52,2,.36,3.91.74,5.76,1l5.33.85c3.39.59,6.48.94,9.19,1.31l3.78.5,3.18.33,4.41.48,1.14.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.08,347.09a3.52,3.52,0,0,1-.37-.24l-1-.75c-.91-.65-2.21-1.68-4-2.9a147.3,147.3,0,0,0-15.38-9.44,145.54,145.54,0,0,0-24.67-10.26,141.35,141.35,0,0,0-32.13-5.92c-11.61-.85-22.69.28-32.78.51a129.21,129.21,0,0,1-14.35-.29,97.76,97.76,0,0,1-29.63-7.21c-2-.83-3.47-1.53-4.48-2l-1.14-.58-.38-.21a1.85,1.85,0,0,1,.41.16l1.17.52c1,.46,2.53,1.13,4.51,1.92a101.42,101.42,0,0,0,17.26,5.19,99.57,99.57,0,0,0,12.32,1.74,133.67,133.67,0,0,0,14.29.23c10.06-.26,21.17-1.41,32.84-.56a140.18,140.18,0,0,1,32.26,6,144.05,144.05,0,0,1,24.71,10.42A137.37,137.37,0,0,1,442.85,343c1.73,1.24,3,2.31,3.9,3l1,.8A2.85,2.85,0,0,1,448.08,347.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.71,303a4.21,4.21,0,0,1-.77.27l-2.25.67c-1,.3-2.17.63-3.58.95s-3,.76-4.8,1.08-3.74.75-5.87,1-4.39.6-6.78.87a136.49,136.49,0,0,1-15.66.61,140.52,140.52,0,0,1-15.62-1.29c-2.38-.38-4.64-.71-6.74-1.17s-4-.86-5.81-1.3-3.35-.89-4.74-1.29-2.58-.77-3.54-1.1l-2.22-.77a4.93,4.93,0,0,1-.76-.3,3.89,3.89,0,0,1,.8.18l2.25.66c1,.3,2.16.65,3.56,1s3,.83,4.75,1.2,3.71.85,5.81,1.22,4.35.75,6.72,1.11A147.47,147.47,0,0,0,329,307.83a145.67,145.67,0,0,0,15.59-.56c2.38-.26,4.65-.47,6.76-.81s4.07-.63,5.86-1,3.39-.69,4.8-1,2.62-.59,3.6-.85l2.27-.55A3.74,3.74,0,0,1,368.71,303Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,361.66s.26.14.74.44l2.16,1.33c1.9,1.15,4.68,2.91,8.4,4.9a55.78,55.78,0,0,0,14.28,5.53,34.62,34.62,0,0,0,4.57.7,7.14,7.14,0,0,0,4.62-1,3.72,3.72,0,0,0,1.38-2,5,5,0,0,0,0-2.53,7.76,7.76,0,0,0-3.15-4.23c-12.52-8.3-30.15-14.35-50.1-14.91-2.49-.08-5-.08-7.56,0s-5.16.68-6.87,2.58a4.69,4.69,0,0,0-1.31,3.38,6.09,6.09,0,0,0,1.4,3.46c1.61,2.06,3.93,3.49,6.16,5,9,6.1,18.53,12.16,29.25,16.36s22.11,6.09,32.84,4.5a47.35,47.35,0,0,0,7.8-1.84,13.5,13.5,0,0,0,6.47-4.08,11.44,11.44,0,0,0,2.31-7.07,16.69,16.69,0,0,0-1.62-7.22,26.05,26.05,0,0,0-9.66-10.49,46.9,46.9,0,0,0-12.53-5.41c-4.25-1.23-8.46-2.11-12.48-3l-11.57-2.62-34.91-7.93-9.48-2.19-2.46-.58c-.56-.13-.84-.22-.84-.22l.85.16,2.48.52,9.51,2.08,34.95,7.74,11.57,2.58c4,.91,8.24,1.77,12.52,3a47.2,47.2,0,0,1,12.68,5.45,26.56,26.56,0,0,1,9.88,10.7,17.29,17.29,0,0,1,1.68,7.46,12,12,0,0,1-2.42,7.43,14.09,14.09,0,0,1-6.74,4.28,46.47,46.47,0,0,1-7.91,1.87c-10.86,1.62-22.39-.31-33.14-4.52S308.4,371,299.42,364.87c-2.22-1.54-4.58-3-6.28-5.17a6.63,6.63,0,0,1-1.53-3.8,5.28,5.28,0,0,1,1.47-3.79,7.77,7.77,0,0,1,3.39-2.12,15.28,15.28,0,0,1,3.87-.64c2.58-.1,5.11-.09,7.61,0,20.07.61,37.75,6.71,50.35,15.13a8.16,8.16,0,0,1,3.29,4.48,5.41,5.41,0,0,1,0,2.74,4,4,0,0,1-1.53,2.18,7.55,7.55,0,0,1-4.87,1.07,36.71,36.71,0,0,1-4.63-.73,55.47,55.47,0,0,1-14.31-5.66c-3.72-2-6.48-3.82-8.36-5-.92-.59-1.63-1-2.12-1.38S325,361.66,325,361.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.89,372.33a6.37,6.37,0,0,1-1-.19c-.62-.17-1.55-.35-2.74-.56a34.29,34.29,0,0,0-10.24.08,52.45,52.45,0,0,0-14.45,4.66,143.53,143.53,0,0,0-16.06,9.56,130.63,130.63,0,0,1-16.21,9.5,50.19,50.19,0,0,1-14.68,4.4,32.08,32.08,0,0,1-10.33-.29,22.43,22.43,0,0,1-2.72-.72,5.29,5.29,0,0,1-.92-.34,6.75,6.75,0,0,1,.95.22c.62.18,1.54.38,2.73.61a33.52,33.52,0,0,0,10.23.09,50.74,50.74,0,0,0,14.5-4.48,134.85,134.85,0,0,0,16.11-9.5,139.21,139.21,0,0,1,16.16-9.56,51.3,51.3,0,0,1,14.63-4.58,32.78,32.78,0,0,1,10.34.12A23.08,23.08,0,0,1,444,372,5.11,5.11,0,0,1,444.89,372.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.85,388.61c0,.06-.78-.26-2.22-.58a17.16,17.16,0,0,0-6.19-.2,35.33,35.33,0,0,0-8.83,2.72,81.1,81.1,0,0,0-10.07,5.27c-3.48,2.06-6.8,4.07-10,5.6a41.24,41.24,0,0,1-8.81,3.17,25.28,25.28,0,0,1-6.28.62,13.64,13.64,0,0,1-1.71-.15,2.2,2.2,0,0,1-.59-.11c0-.07.83,0,2.3,0a27.46,27.46,0,0,0,6.19-.8,43.15,43.15,0,0,0,8.66-3.26c3.14-1.54,6.43-3.55,9.92-5.62A76.11,76.11,0,0,1,424.4,390a34.06,34.06,0,0,1,9-2.63,16.29,16.29,0,0,1,6.3.4,14.23,14.23,0,0,1,1.63.55A2.12,2.12,0,0,1,441.85,388.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,305.75c0,.17-6.33-1.07-14.06-2.77s-14-3.21-13.93-3.37,6.33,1.07,14.06,2.77S389,305.59,389,305.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.51,343.69l-5.14-1.12-1.44,6.62-9.55-2.07,1.44-6.63-18.29-4,1.39-6.38,20.23-18.22,10.14,2.2-18.5,17.16,7,1.52,1.28-5.88,9.25,2-1.28,5.89,5.14,1.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.82,333.44C350.3,322,358.16,316.85,367,318.77s13.8,9.89,11.31,21.31-10.35,16.6-19.14,14.68S345.33,344.86,347.82,333.44Zm20.66,4.5c1.58-7.26-.1-10.48-3.21-11.16s-6,1.54-7.62,8.8.11,10.49,3.27,11.18S366.9,345.21,368.48,337.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,358.6l-5.14-1.12-1.44,6.63L395.86,362l1.45-6.63-18.29-4,1.39-6.38,20.22-18.22L410.77,329l-18.49,17.15,7,1.53,1.28-5.89,9.24,2-1.28,5.88,5.14,1.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.19,368.23l-.51,2.17L325.27,368l3.25-13.88,10.14,2.37-.51,2.16-7.55-1.77-.85,3.61,6.7,1.58-.49,2.12-6.71-1.57-.9,3.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.65,373.2l-1.88-4.73a4.29,4.29,0,0,1-.54-.11l-3.14-.73-.95,4-2.58-.6,3.26-13.89,5.71,1.34c3.65.86,5.48,3.25,4.76,6.33a4.57,4.57,0,0,1-4,3.69l2.13,5.31Zm-.75-12.52-3-.71-1.3,5.54,3,.7c2.26.53,3.68-.23,4.09-2S349.16,361.21,346.9,360.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.15,376.6l-1.88-4.73a5.17,5.17,0,0,1-.54-.11L356.6,371l-1,4.05-2.58-.61,3.25-13.89,5.72,1.34c3.65.86,5.47,3.25,4.75,6.33a4.56,4.56,0,0,1-4,3.69l2.12,5.31Zm-.74-12.52-3-.71-1.3,5.54,3,.7c2.26.53,3.67-.23,4.08-2S363.67,364.61,361.41,364.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.21,370.69c1-4.1,4.85-6.39,9.15-5.38s6.78,4.77,5.81,8.89-4.85,6.4-9.15,5.39S367.25,374.8,368.21,370.69Zm12.36,2.9a5,5,0,1,0-6,3.74A4.86,4.86,0,0,0,380.57,373.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.37,383.92l-1.88-4.73-.55-.11-3.13-.73-.95,4-2.58-.6,3.26-13.89,5.71,1.34c3.65.86,5.48,3.25,4.76,6.33a4.58,4.58,0,0,1-4,3.69l2.13,5.31Zm-.75-12.53-3-.7-1.3,5.53,3,.71c2.27.53,3.68-.23,4.09-2S394.88,371.92,392.62,371.39Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ballon--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.66,143.24a2.56,2.56,0,0,1,.38.19l1.07.61a30.24,30.24,0,0,1,3.83,2.78,34,34,0,0,1,9.85,14.2,35.77,35.77,0,0,1,2.1,11.84,38.69,38.69,0,0,1-2.37,13.59,37.24,37.24,0,0,1-8,13,30.11,30.11,0,0,1-6.31,5.08,28,28,0,0,1-7.72,3.17,51.84,51.84,0,0,1-16.34.95c-5.29-.39-10.34-1.08-15.18-1.3a45.71,45.71,0,0,0-13.63,1.11,25.79,25.79,0,0,0-10.57,5.27,17.47,17.47,0,0,0-5.38,8.06,16.3,16.3,0,0,0-.69,7.33,13,13,0,0,0,1.46,4.44c.53.94.88,1.39.85,1.41a11.52,11.52,0,0,1-.94-1.36,12.66,12.66,0,0,1-1.57-4.46,16.26,16.26,0,0,1,.61-7.45,17.72,17.72,0,0,1,5.42-8.25,26,26,0,0,1,10.71-5.4A45.52,45.52,0,0,1,310,206.86c4.87.21,9.93.89,15.19,1.27a51.66,51.66,0,0,0,16.19-.94,27.89,27.89,0,0,0,7.58-3.11,29.9,29.9,0,0,0,6.2-5,36.78,36.78,0,0,0,7.88-12.8,38.48,38.48,0,0,0,2.39-13.43,35.4,35.4,0,0,0-2-11.71,33.68,33.68,0,0,0-13.39-17l-1-.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.48,17c2.6,7.54,5.21,15.2,5.58,23.16S283.22,56.55,277.44,62c-6.7,6.36-16.64,7.57-25.83,8.46,6.61.23,13.86,1.8,17.82,7.1,4.54,6.07,3.06,14.75,0,21.67s-7.65,13.37-8.9,20.85a34.59,34.59,0,0,1,53.09,29.74c5.69-10.73,15.45-19.51,27.14-22.8s25.17-.6,33.91,7.83a44.8,44.8,0,0,1,12.26-63c-5.32,4.42-13.64,3.89-19.3-.09s-8.88-10.7-10.08-17.51-.61-13.79,0-20.68c-6,7.79-18.43,9.56-26.35,3.74-8.12-6-10.17-17-11.6-27,.74,9.78-6.75,19.49-16.4,21.26s-20.09-4.66-22.87-14.06",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.68,137.57c-.71,4.71.6,9.53,2.06,14.06A5.9,5.9,0,0,0,347,154a2.31,2.31,0,0,0,2.47.65,3.14,3.14,0,0,0,1.48-2,16.84,16.84,0,0,0,.91-5.45c1.49,1.1,3.1,2.25,5,2.34s3.89-1.42,3.6-3.25a4.73,4.73,0,0,0-1.75-2.54l-9.89-9.13-5.07,2.95",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.88,42.4s-26.31,19.42-18.26,50.47l2.65.33,9.29-9.62,12.8,17.78-1.78-18.13,5.48,4,9.39-19.62s-14-10-12-19.79C298.49,47.78,290.26,47.32,290.88,42.4Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.64,108A37.45,37.45,0,0,0,292,129.24l15.62-9.41S287.32,116.13,280.64,108Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.37,128.76s7.21,11.61,25.52,11c13-.44,21.39-17,18.15-32.83l-10.6,8-3.93-2.56,0,8.36s-4.27,6.17-9.79,2.69C332.74,123.42,327.94,133.62,313.37,128.76Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.12,39.05c-.62.27,12.51,15.74,12.62,25,0,0,4.33-8.45,13.16-8.81,0,0,.32-7.32,7.45-5.79C353.35,49.43,338.12,31.29,320.12,39.05Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.81,69.31s6.21,10.9,6,22c0,0-8.95-9.21-16.18-2.73l-1.81-4.37s4.27-.85,4.25-6S350,70.05,350,70.05,359.79,78.26,362.81,69.31Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.29,96.09c0,.14-11.4,3-25.54,6.42s-25.63,6-25.66,5.91,11.4-3,25.54-6.42S309.26,96,309.29,96.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.29,78c-.05.13-6.2-2-13.75-4.71s-13.62-5-13.57-5.19,6.2,2,13.75,4.71S312.34,77.87,312.29,78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.28,10.52c.14,0,4.93,13.46,10.71,30.17S324.34,71,324.2,71s-4.93-13.45-10.7-30.16S303.15,10.57,303.28,10.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.38,49.33a15,15,0,0,1-.09,3c-.14,1.82-.42,4.34-.88,7.1s-1,5.23-1.46,7a14.52,14.52,0,0,1-.88,2.83,20.49,20.49,0,0,1,.52-2.92c.37-1.79.85-4.26,1.31-7s.79-5.24,1-7.05A18.33,18.33,0,0,1,341.38,49.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5,51.23c.07.13-8.68,5.37-19.55,11.71s-19.73,11.38-19.8,11.25,8.67-5.36,19.54-11.7S379.42,51.11,379.5,51.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.6,99.87a7.15,7.15,0,0,1-1.45-.1c-.93-.11-2.28-.27-3.93-.5-3.32-.45-7.89-1.14-12.93-2s-9.57-1.76-12.84-2.46c-1.64-.34-3-.64-3.87-.86a6.54,6.54,0,0,1-1.4-.39,8.78,8.78,0,0,1,1.44.2l3.9.69,12.86,2.31,12.89,2.16,3.91.65A7.59,7.59,0,0,1,379.6,99.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.14,143.05c-.11.1-7.73-8.2-17-18.54s-16.75-18.81-16.64-18.9,7.73,8.21,17,18.55S365.25,143,365.14,143.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.51,139.34a4.88,4.88,0,0,1,.37-1.14c.26-.73.67-1.77,1.19-3,1-2.55,2.53-6.06,4.26-9.9s3.38-7.29,4.6-9.76c.62-1.23,1.13-2.23,1.49-2.91a4.76,4.76,0,0,1,.62-1,6.13,6.13,0,0,1-.44,1.12l-1.33,3c-1.19,2.62-2.75,6-4.46,9.81s-3.23,7.22-4.4,9.84c-.53,1.18-1,2.17-1.35,3A4.92,4.92,0,0,1,304.51,139.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.26,89c0-.09.8-.17,2-.65a8.64,8.64,0,0,0,5.46-7.61c.07-1.27-.11-2.07,0-2.08a4.29,4.29,0,0,1,.39,2.09,8.24,8.24,0,0,1-5.69,7.94A4.31,4.31,0,0,1,312.26,89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.55,103.2c-.08,0,.35-.71.58-1.93A6.22,6.22,0,0,0,316.58,94c-1.18-.34-2-.25-2-.34a3.54,3.54,0,0,1,2.07,0,6.24,6.24,0,0,1,4.82,7.76A3.52,3.52,0,0,1,320.55,103.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.05,94.72c0,.08-.88-.25-2.31-.42a11.59,11.59,0,0,0-5.49.7,11.47,11.47,0,0,0-4.47,3.26c-.93,1.11-1.32,1.93-1.4,1.89A5.4,5.4,0,0,1,327.49,98a10.53,10.53,0,0,1,10.3-4.09A5.45,5.45,0,0,1,340.05,94.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.52,88.88a3.19,3.19,0,0,1-1.72-.38,6.4,6.4,0,0,1-3.07-2.93,6.32,6.32,0,0,1-.48-4.22,3,3,0,0,1,.73-1.59c.08,0-.22.63-.37,1.66a6.7,6.7,0,0,0,.59,3.92A6.78,6.78,0,0,0,338,88.17C338.88,88.67,339.53,88.79,339.52,88.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.62,76.3a5,5,0,0,1-1.29,1.06,7.6,7.6,0,0,1-3.78,1.47,4.19,4.19,0,0,1-3.65-1.73c-.6-.95-.39-1.68-.35-1.65a5.19,5.19,0,0,0,.65,1.43,4,4,0,0,0,3.32,1.43,8.79,8.79,0,0,0,3.62-1.26A5.52,5.52,0,0,1,333.62,76.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M343.54,138.85a25.21,25.21,0,0,0,5.78-3.71l1.85,1.71c-2.52,1.81-5.44,3.51-7.56,5.78a20.21,20.21,0,0,1-.07-3.78"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M349.87,134.54A10.23,10.23,0,0,1,343,139c0-.15,1.72-.71,3.59-1.94S349.75,134.44,349.87,134.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.87,134.79a6.07,6.07,0,0,1-1.07.54,12.31,12.31,0,0,1-1.31.52,17.93,17.93,0,0,1-1.78.57,27.51,27.51,0,0,1-4.78.88,31.36,31.36,0,0,1-5.95-.07,32,32,0,0,1-5.82-1.3,26.93,26.93,0,0,1-4.45-2c-.62-.31-1.13-.67-1.6-1a8.94,8.94,0,0,1-1.15-.81,5.55,5.55,0,0,1-.92-.77c.07-.08,1.41,1,3.85,2.22a29.76,29.76,0,0,0,4.42,1.82,30.19,30.19,0,0,0,11.58,1.35,30.23,30.23,0,0,0,4.73-.76C344.27,135.41,345.82,134.69,345.87,134.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.45,151.25a9.13,9.13,0,0,1-1.34-3.87,9.24,9.24,0,0,1,0-4.1c.16,0,.15,1.82.53,4S346.59,151.19,346.45,151.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.68,124.67a7.25,7.25,0,0,1-1.7-1.42,30,30,0,0,1-6.11-8.76,7.74,7.74,0,0,1-.75-2.09c.15-.07,1.46,3,3.84,6.44S290.79,124.56,290.68,124.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.29,57.78c.08.06-.93,1.56-2.26,4.14a48.63,48.63,0,0,0-5.41,21.79c0,2.91.15,4.7.06,4.71a5.53,5.53,0,0,1-.21-1.25,32.47,32.47,0,0,1-.22-3.46,44.06,44.06,0,0,1,1.3-11.34,44.75,44.75,0,0,1,4.15-10.63c.72-1.27,1.34-2.28,1.82-3A5.45,5.45,0,0,1,281.29,57.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.65,49.1c.09.11-.53.78-1.4,1.49s-1.64,1.19-1.73,1.08.54-.78,1.4-1.49S288.56,49,288.65,49.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.09,294.64a2.17,2.17,0,0,1,.56.66,4,4,0,0,1,.53,2.43,6,6,0,0,1-1.71,3.53,12.86,12.86,0,0,1-4.28,3,12.53,12.53,0,0,1-6.24,1,11.91,11.91,0,0,1-6.6-3,11.68,11.68,0,0,1-3.57-7.13,16.14,16.14,0,0,1,1.27-8.5,27.49,27.49,0,0,1,4.67-7.22c1.82-2.1,3.72-4,5.24-6a15.94,15.94,0,0,0,3.13-6.32,14,14,0,0,0-4.55-13.73,20.29,20.29,0,0,0-2.71-1.91,10.55,10.55,0,0,1,2.84,1.75,14.16,14.16,0,0,1,4.79,7.66,14.57,14.57,0,0,1,.06,6.32,16.29,16.29,0,0,1-3.18,6.52c-1.54,2.05-3.44,3.94-5.23,6a27.37,27.37,0,0,0-4.58,7.1,15.63,15.63,0,0,0-1.24,8.22,11.19,11.19,0,0,0,3.39,6.85,11.49,11.49,0,0,0,6.32,2.9,12.33,12.33,0,0,0,6.05-.88c3.48-1.47,5.77-4,5.93-6.19a4.08,4.08,0,0,0-.42-2.35C309.3,294.86,309.06,294.66,309.09,294.64Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.55,427.8c2.94-13.71,19.73-113.21,19.73-113.21s-12.11,1.92-14.55,6.26C109,325.62,96,398.93,94.54,423.8a23.9,23.9,0,0,0-3.59,0,13,13,0,0,0-8.17,3.46,9.85,9.85,0,0,0-2.18,10.08,9.73,9.73,0,0,0,3.49,4.47c-.19,2.13.49,4.74,2.16,5.83a5.8,5.8,0,0,0,6.46-.17,3.58,3.58,0,0,0,6.43.85c.8,1.86,3.42,2,5.31,1.34a11.38,11.38,0,0,0,7-8.3,14.09,14.09,0,0,0-2.34-10.74A17,17,0,0,0,106.55,427.8Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109,413.53c-7.16-12.58-10.81-26-5.38-45.46,3.88-13.95,11.62-28.22,18.74-40.83"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M105.08,440.27a5.7,5.7,0,0,0,.88-.76,3.35,3.35,0,0,0,.72-2.91,3.91,3.91,0,0,0-3.25-2.81A5.45,5.45,0,0,0,98.5,436a9.14,9.14,0,0,0-1.85,5.33,10.68,10.68,0,0,0,.86,4.6,11.92,11.92,0,0,0,2.52,3.55s-.1,0-.27-.16a4.3,4.3,0,0,1-.68-.57,8.92,8.92,0,0,1-1.91-2.67,10.79,10.79,0,0,1-1-4.77,9.52,9.52,0,0,1,1.92-5.64,5.92,5.92,0,0,1,5.41-2.33,4.29,4.29,0,0,1,3.54,3.21,3.52,3.52,0,0,1-.93,3.13,2.8,2.8,0,0,1-.73.53C105.19,440.26,105.08,440.29,105.08,440.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.93,441.16a8,8,0,0,1,1,.53,7.86,7.86,0,0,0,2.87.81,7.66,7.66,0,0,0,4.26-.83,6,6,0,0,0,2-1.62,3.27,3.27,0,0,0,.66-2.51,8.06,8.06,0,0,0-2.42-4.2,9.77,9.77,0,0,0-3.51-2.17l-.61-.22.63-.16a28.17,28.17,0,0,0,4.55-1.72,4.47,4.47,0,0,1-1.11.74,15.39,15.39,0,0,1-3.35,1.36l0-.38a10,10,0,0,1,3.71,2.2,9.67,9.67,0,0,1,1.61,1.95,6.65,6.65,0,0,1,1,2.53,3.76,3.76,0,0,1-.77,2.89,6.47,6.47,0,0,1-2.16,1.74,7.84,7.84,0,0,1-4.52.77,7.28,7.28,0,0,1-2.93-1,4.33,4.33,0,0,1-.67-.49Q82.92,441.18,82.93,441.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.05,441.33c.17.06-.43,1.49-.2,3.28a24.88,24.88,0,0,0,1,3.15,4.65,4.65,0,0,1-1.49-3.08A4.43,4.43,0,0,1,92.05,441.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.42,434.31a4.48,4.48,0,0,0-.46-1.22,2.43,2.43,0,0,0-1-.85,2.66,2.66,0,0,0-1.62-.14,4.54,4.54,0,0,0-2.55,1.71c-.51.65-.76,1.11-.83,1.07s.07-.54.53-1.28a4.35,4.35,0,0,1,2.74-2,3,3,0,0,1,1.94.21,2.64,2.64,0,0,1,1.14,1.1C99.71,433.74,99.47,434.34,99.42,434.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.23,430.86a4.79,4.79,0,0,1,4.6,1.24,7.26,7.26,0,0,1,4-2.46,3.27,3.27,0,0,1,3.73,2.23,4,4,0,0,1,5.61,3.21,5.54,5.54,0,0,0-6.91-.78,2.37,2.37,0,0,0-1.68-2.2,3.37,3.37,0,0,0-2.83.52,5.83,5.83,0,0,0-1.86,2.28A9.18,9.18,0,0,0,88,430.83"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M84.75,440.6A4.68,4.68,0,0,1,83,439.17a8.65,8.65,0,0,1-.76-10.47A4.74,4.74,0,0,1,83.76,427c.07.06-.57.67-1.25,1.87a9,9,0,0,0,.73,10.05C84.09,440,84.81,440.53,84.75,440.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.61,245.25c-.66-1.91-2.46-3.82-4.4-3.27a3.57,3.57,0,0,0-4.73-4.43,5.8,5.8,0,0,0-4-5.12c-1.91-.6-4.35.52-5.88,2a9.62,9.62,0,0,0-5.67.13,9.83,9.83,0,0,0-6.43,8,13,13,0,0,0,2.49,8.52,33.68,33.68,0,0,0,5.24,5.7c-10.3,48.09-63.07,56.45-63.07,56.45l4.95,19.36c50.57-12.49,64.5-52.81,68.29-71.75.45,0,.89,0,1.33,0a14.12,14.12,0,0,0,9.8-5A11.37,11.37,0,0,0,301.61,245.25Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.73,251.68a.85.85,0,0,1,.11.29,2.64,2.64,0,0,1,.06.91,3.5,3.5,0,0,1-1.83,2.69,4.29,4.29,0,0,1-4.73-.71,5.89,5.89,0,0,1-1.62-5.66,9.53,9.53,0,0,1,3.15-5.06,10.78,10.78,0,0,1,4.33-2.24,8.87,8.87,0,0,1,3.28-.21,4,4,0,0,1,.87.17c.2,0,.3.09.29.1a12.05,12.05,0,0,0-4.34.3,10.88,10.88,0,0,0-4.12,2.24,9.22,9.22,0,0,0-2.95,4.81,5.45,5.45,0,0,0,1.43,5.19,3.91,3.91,0,0,0,4.24.75,3.4,3.4,0,0,0,1.8-2.4A8.65,8.65,0,0,0,294.73,251.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.4,234s.1,0,.29,0a5.16,5.16,0,0,1,.82.22,7.29,7.29,0,0,1,2.63,1.62,7.91,7.91,0,0,1,2.26,4,6.26,6.26,0,0,1,0,2.76,3.8,3.8,0,0,1-1.75,2.43,6.65,6.65,0,0,1-2.6.83,10,10,0,0,1-6.57-1.5l.28-.25a16.21,16.21,0,0,1,1.07,3.45,4.06,4.06,0,0,1,.12,1.33,26.41,26.41,0,0,0-1.55-4.62l-.27-.58.56.34a9.71,9.71,0,0,0,3.9,1.33,8,8,0,0,0,4.79-.78,3.27,3.27,0,0,0,1.52-2.1,5.88,5.88,0,0,0,0-2.54,7.71,7.71,0,0,0-2.05-3.83,7.94,7.94,0,0,0-2.45-1.71C281.78,234.1,281.39,234,281.4,234Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.31,240.92a4.42,4.42,0,0,1,2.14-2.67,4.68,4.68,0,0,1,3.33-.79,23.12,23.12,0,0,0-3.06,1.23C288.19,239.64,287.45,241,287.31,240.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.53,251.07c.05,0-.26.59-1.18.78a2.73,2.73,0,0,1-1.58-.19,3,3,0,0,1-1.39-1.37,4.37,4.37,0,0,1-.18-3.39c.29-.82.6-1.26.66-1.23a6.87,6.87,0,0,1-.3,1.33,4.5,4.5,0,0,0,.28,3.05,2.69,2.69,0,0,0,1.14,1.17,2.32,2.32,0,0,0,1.31.26A4,4,0,0,0,286.53,251.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M276.77,244.59a4.79,4.79,0,0,0,3.88,2.77,7.31,7.31,0,0,0,.63,4.67c.82,1.37,2.68,2.23,4.09,1.48a4,4,0,0,0,6,2.31,5.55,5.55,0,0,1-5-4.86,2.37,2.37,0,0,1-2.77.09,3.33,3.33,0,0,1-1.38-2.52,5.76,5.76,0,0,1,.58-2.88,9.15,9.15,0,0,1-6.22-1.19"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M147.66,431.71q4.77,20.22,9.52,40.45a22.65,22.65,0,0,0-14.29,2.66c-1.5.85-3.09,2.52-2.28,4,.63,1.2,2.28,1.29,3.63,1.23,10.52-.45,21,.44,31.58,0l-.58-41",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7,431.71q-4.75,20.22-9.52,40.45a22.67,22.67,0,0,1,14.3,2.66c1.5.85,3.08,2.52,2.28,4-.64,1.2-2.28,1.29-3.63,1.23-10.53-.45-21,.44-31.58,0l.58-41",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.88,441.13l1.31,5.35c8.6.47,16.94,1.77,24.16.18l-.07-4.72s-8.9-.47-14-1.81h0l2.33,4.27A63.54,63.54,0,0,1,149.88,441.13Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M177,446.58s8.48,2.3,16.66.88c6.92-1.19,7.89-2.44,7.89-2.44L203.7,436s-9.58,5.47-24.47,2.52L187,441.7l-9.92,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M243.19,379.84a92.44,92.44,0,0,0-12.34-18.72l0-.07a30.65,30.65,0,0,0,8,.59,45.71,45.71,0,0,1-11.72-12.83c-4.09-15.09-8.47-30.25-8.56-45.67l-91.75-.71a283,283,0,0,1-12.68,54c-6.33,19-13.48,41.61-.85,60.22a33.82,33.82,0,0,0,8.54,8.5,124,124,0,0,0,12.62,11.63q-1.16-2.93-2.29-5.85l1.57.7A62.3,62.3,0,0,0,165,445l-1.7-4.07c13.14,2.28,26.49,1.59,38.42-4,22.27-10.5,34-22.93,36.76-39.23,1.41-8.26-.19-15.68-2.67-23.09Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.91,384.37s-.13,0-.37,0-.6-.1-1-.21a28.48,28.48,0,0,1-3.81-1.14,32,32,0,0,1-11.28-7.26l.42-.28c.44,1.13.9,2.3,1.36,3.5.84,2.18,1.66,4.28,2.41,6.22l.57,1.48-1-1.23c-2.86-3.55-5.34-6.62-7.16-8.89l-2-2.59a7.85,7.85,0,0,1-.69-1,5.43,5.43,0,0,1,.82.86l2.15,2.51,7.31,8.76-.43.25c-.75-1.94-1.57-4-2.42-6.21-.47-1.2-.92-2.38-1.36-3.5l-.44-1.14.86.87a33.52,33.52,0,0,0,11,7.3,38,38,0,0,0,3.73,1.29A12.54,12.54,0,0,1,212.91,384.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.65,366.22a9,9,0,0,1-1-2.38,26.16,26.16,0,0,1-1.25-6.14,26.42,26.42,0,0,1,.23-6.26,9.17,9.17,0,0,1,.63-2.52,21.29,21.29,0,0,1-.26,2.56,33.09,33.09,0,0,0-.08,6.17,34,34,0,0,0,1.08,6.08A22,22,0,0,1,133.65,366.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.72,358.4a5.35,5.35,0,0,1-.63-1.81,20.51,20.51,0,0,1-.58-4.57,21.17,21.17,0,0,1,.44-4.58,5.86,5.86,0,0,1,.58-1.82,62.29,62.29,0,0,0-.5,6.4A61,61,0,0,0,136.72,358.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.31,417.13a2.16,2.16,0,0,1-.55-.1c-.36-.09-.89-.2-1.56-.4a47,47,0,0,1-5.59-2,52.42,52.42,0,0,1-16.3-10.92l.39-.34c.21.28.42.59.64.9a34.71,34.71,0,0,1,4.48,9.18l.19.6-.54-.32a27.44,27.44,0,0,1-9.59-9.34,26.63,26.63,0,0,1-1.77-3.44c-.17-.42-.28-.75-.36-1a1.3,1.3,0,0,1-.1-.35,10.2,10.2,0,0,1,.61,1.24,30.29,30.29,0,0,0,1.87,3.35,28,28,0,0,0,9.58,9.08l-.35.29a34.86,34.86,0,0,0-4.45-9l-.62-.89.39-.34a54.4,54.4,0,0,0,16.07,11,57,57,0,0,0,5.51,2.12c.66.23,1.18.37,1.52.49A2.75,2.75,0,0,1,169.31,417.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.35,324.06a1.08,1.08,0,0,1,0,.24c0,.18,0,.41,0,.68-.05.61-.16,1.49-.31,2.63-.32,2.27-.92,5.55-1.89,9.53s-2.34,8.69-4,13.86-3.49,10.83-5.18,16.85A125.79,125.79,0,0,0,107.21,385a59.35,59.35,0,0,0-.23,14.31,40.89,40.89,0,0,0,2.19,9.4c.42,1.06.75,1.89,1,2.43l.27.63a.77.77,0,0,1,.08.22s0-.06-.13-.19-.19-.37-.32-.61c-.29-.53-.65-1.35-1.09-2.41a38.81,38.81,0,0,1-2.38-9.43,58.29,58.29,0,0,1,.13-14.42,122,122,0,0,1,3.69-17.27c1.71-6,3.59-11.68,5.23-16.85s3.06-9.83,4.07-13.79,1.67-7.22,2-9.48c.18-1.13.32-2,.4-2.61l.11-.68A.79.79,0,0,1,122.35,324.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.25,421.74a5.94,5.94,0,0,1-.65-.54c-.39-.37-1-.87-1.76-1.64a35.87,35.87,0,0,1-5.38-7,46,46,0,0,1-5-12.15,58.69,58.69,0,0,1-1.75-16,86.58,86.58,0,0,1,2.06-15.95c1.06-4.83,2.3-9.11,3.41-12.68s2.09-6.42,2.77-8.39c.34-.95.6-1.71.8-2.27a5.05,5.05,0,0,1,.32-.78,6.27,6.27,0,0,1-.22.82c-.17.56-.41,1.33-.71,2.29-.62,2-1.54,4.87-2.61,8.44s-2.26,7.85-3.29,12.67a88.58,88.58,0,0,0-2,15.86A59.8,59.8,0,0,0,114,400.27a46.61,46.61,0,0,0,4.83,12.08,37.85,37.85,0,0,0,5.21,7.07c.68.79,1.31,1.3,1.68,1.71A4.37,4.37,0,0,1,126.25,421.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.63,424.81a35.05,35.05,0,0,1-4.83-3.73,34.56,34.56,0,0,1-4.49-4.13,36.06,36.06,0,0,1,4.82,3.73A36,36,0,0,1,135.63,424.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.37,144.06c-.75.19-19.23,8.73-15.75,33.24,3,21.47,15.75,22,15.75,22l23.68-20.7s-17.19-1.83-21.63-14.36C96.91,151.49,99.37,144.06,99.37,144.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.72,173.77c0,.1-1.71.06-4.36.7A21.68,21.68,0,0,0,90,187.94c-1,2.55-1.16,4.26-1.26,4.24a4.9,4.9,0,0,1,.1-1.2,19.09,19.09,0,0,1,.81-3.17,21,21,0,0,1,15.59-13.7,17.73,17.73,0,0,1,3.25-.39A4.48,4.48,0,0,1,109.72,173.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.67,166c0,.1-1.39-.16-3.6,0a17.08,17.08,0,0,0-13.84,9c-1,2-1.37,3.31-1.47,3.28a3.15,3.15,0,0,1,.19-1,13.74,13.74,0,0,1,1-2.49,16.49,16.49,0,0,1,14.14-9.21,14.1,14.1,0,0,1,2.66.13A3.17,3.17,0,0,1,102.67,166Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.62,161.65s0-.25.22-.67a9.11,9.11,0,0,1,1-1.66,10.54,10.54,0,0,1,5.13-3.67,8.82,8.82,0,0,1,6.28.34,7.63,7.63,0,0,1,1.67,1c.36.27.53.46.51.48s-.83-.56-2.32-1.1a9.08,9.08,0,0,0-6-.19,11.06,11.06,0,0,0-5,3.41C85.11,160.77,84.71,161.69,84.62,161.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.76,148.34s-.48.53-1.35,1.47a33.81,33.81,0,0,0-3.32,4.26,32.57,32.57,0,0,0-1.6,33.82,34.71,34.71,0,0,0,2.91,4.55c.77,1,1.23,1.56,1.2,1.59a2.26,2.26,0,0,1-.38-.36c-.22-.25-.58-.6-1-1.11a29.21,29.21,0,0,1-3.07-4.5,32.07,32.07,0,0,1,1.61-34.2,29.85,29.85,0,0,1,3.49-4.19c.44-.47.83-.78,1.08-1A1.79,1.79,0,0,1,94.76,148.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.61,146.17c.74.18,19.22,8.73,15.74,33.24-3,21.47-15.74,22-15.74,22l-23.68-20.69s17.18-1.83,21.63-14.36C242.06,153.6,239.61,146.17,239.61,146.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.25,175.87a5.16,5.16,0,0,1,1.2-.05,18.87,18.87,0,0,1,3.25.4,20.93,20.93,0,0,1,15.59,13.7,19.09,19.09,0,0,1,.81,3.17,4.62,4.62,0,0,1,.11,1.19c-.11,0-.29-1.68-1.27-4.24a21.65,21.65,0,0,0-15.32-13.46C231,175.94,229.24,176,229.25,175.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.79,168.19a3.42,3.42,0,0,1,.94-.22,13.43,13.43,0,0,1,2.61-.14,15.55,15.55,0,0,1,8.13,2.73A16.71,16.71,0,0,1,254.1,177a14.31,14.31,0,0,1,.93,2.45,3.07,3.07,0,0,1,.18.94c-.09,0-.42-1.3-1.44-3.22a17.73,17.73,0,0,0-5.59-6.22,16.25,16.25,0,0,0-7.86-2.79C238.15,168,236.8,168.29,236.79,168.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.35,163.76c-.08,0-.48-.88-1.48-2.11a11,11,0,0,0-5-3.4,9,9,0,0,0-6,.19c-1.49.54-2.26,1.18-2.32,1.1s.15-.21.51-.49a8.06,8.06,0,0,1,1.67-1,8.89,8.89,0,0,1,6.29-.34,10.56,10.56,0,0,1,5.12,3.68,8.78,8.78,0,0,1,1,1.66A1.74,1.74,0,0,1,254.35,163.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.28,148.39a5.77,5.77,0,0,1,.41,1.14,9.72,9.72,0,0,1,.36,1.38,18.15,18.15,0,0,1,.34,1.87,21.28,21.28,0,0,1,.2,2.28,26,26,0,0,1,0,2.64,29.12,29.12,0,0,1-1,5.94,28.61,28.61,0,0,1-2.36,5.56c-.48.79-.91,1.56-1.41,2.22a19.39,19.39,0,0,1-1.42,1.81,16.21,16.21,0,0,1-1.29,1.38,8.57,8.57,0,0,1-1.05,1,5.09,5.09,0,0,1-1,.74c-.07-.08,1.29-1.17,3-3.32a21,21,0,0,0,1.34-1.82c.48-.65.89-1.42,1.36-2.2a31,31,0,0,0,2.27-5.48,30.26,30.26,0,0,0,1.06-5.83c0-.91.11-1.77.07-2.59a21.89,21.89,0,0,0-.14-2.25C241.72,150.07,241.17,148.42,241.28,148.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.86,160.31s-3.12.89-1.78-11.61l10.71,11.62s-4.35-7.16-5.52-13.41c0,0,13.54,12.53,18.24,13.41s36.86,2.67,55.61,18.75,27.26,31.66,29.3,48.52c3.32,27.33-1.61,50.62-14.56,66.25l-.44-4.46s-13.85,20.09-34.84,25.9-83.07,0-83.07,0-34.83-9.38-46.89-36.62-5.36-31.26-5.36-31.26l-5.19,4.9s-1.36-39.22,33.77-67C132.53,163.44,154.86,160.31,154.86,160.31Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.42,310.82s-.07.06-.23.14l-.71.37c-.63.32-1.54.8-2.76,1.38-2.42,1.16-6,2.78-10.55,4.49a93.75,93.75,0,0,1-16.7,4.62,63.89,63.89,0,0,1-10.36,1,51.23,51.23,0,0,1-11.28-1.06l.2-.46,8.67,6,1.05.73-1.26-.27-2.32-.49-20.64-4.43.23-.42,4.84,5.1.56.58-.78-.19a122.7,122.7,0,0,1-26.66-9.88c-3.1-1.58-5.47-2.95-7.08-3.92-.81-.48-1.41-.87-1.82-1.13l-.46-.31c-.11-.07-.16-.1-.15-.11l.17.08.48.27,1.86,1.07c1.62.93,4,2.26,7.13,3.8a126.81,126.81,0,0,0,26.64,9.67l-.23.39q-2.35-2.46-4.85-5.08l-.56-.58.79.17,20.64,4.41,2.32.5-.2.46-8.66-6.05-1-.73,1.24.27a51.35,51.35,0,0,0,11.16,1.07,63.48,63.48,0,0,0,10.3-.94,96.31,96.31,0,0,0,16.65-4.49c4.58-1.66,8.15-3.24,10.6-4.34l2.79-1.3.73-.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M222.42,310.82c-16.86,8.45-35.95,14.3-52.53,10.68l8.66,6.05-23-4.92c1.62,1.7,3.24,3.39,4.85,5.09a124.22,124.22,0,0,1-36.22-15.12s18.26,19.08,39.4,20.1C198.46,334.37,222.42,310.82,222.42,310.82Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M105.75,283.94a2.94,2.94,0,0,1-.62-.35c-.39-.25-1-.59-1.71-1.11a40.46,40.46,0,0,1-5.75-4.86A44.6,44.6,0,0,1,85.83,256l.51-.06c0,.12,0,.24,0,.37.15,5.36.3,10.43.44,14.94l0,1.2-.48-1.1a48.32,48.32,0,0,1-3.85-14.3,41.73,41.73,0,0,1-.26-4.2c0-.49,0-.87,0-1.12a1.88,1.88,0,0,1,0-.38,1.65,1.65,0,0,1,0,.38q0,.43.06,1.11c0,1,.15,2.39.39,4.18a50.19,50.19,0,0,0,4,14.14l-.45.1c-.15-4.5-.32-9.58-.5-14.93V256l.52-.06a44.64,44.64,0,0,0,4.93,12.6,45.73,45.73,0,0,0,12.27,13.78c.69.55,1.28.91,1.65,1.2A4,4,0,0,1,105.75,283.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.07,259.17s.09-.17.31-.46l1-1.27c.39-.57.79-1.32,1.3-2.16l.66-1.42.36-.77c.1-.28.21-.56.31-.85,1.81-4.6,2.9-11.45,2.84-19,0-1.07,0-2.13-.11-3.15l-.13-2,.64,1.9c.66,2,1.29,3.86,1.89,5.64h-.46a19.66,19.66,0,0,0,1.24-7.14,20.37,20.37,0,0,0-.88-5.65,27.76,27.76,0,0,0-2-4.69s.09.09.22.28.33.46.55.85a18.2,18.2,0,0,1,1.56,3.47,19.71,19.71,0,0,1,1,5.73,19.49,19.49,0,0,1-1.19,7.32l-.24.65-.22-.66-1.92-5.63.5-.1c.07,1.05.1,2.1.11,3.18.06,7.6-1.09,14.51-3,19.13-.12.29-.23.58-.34.85l-.38.78-.71,1.42c-.54.84-1,1.58-1.39,2.13l-1,1.22C244.21,259.05,244.08,259.19,244.07,259.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.8,184.85a3.75,3.75,0,0,1-.7,0c-.45,0-1.13,0-2-.06a49.55,49.55,0,0,1-7.28-.95,54.49,54.49,0,0,1-22-9.94l.34-.39.17.18c3.28,3.33,6.4,6.51,9.24,9.41l.55.56-.76-.16a24.13,24.13,0,0,1-8-3.15,24.58,24.58,0,0,1-5.23-4.28,23.21,23.21,0,0,1-2.67-3.5c-.27-.43-.44-.79-.57-1s-.19-.36-.17-.36a14.33,14.33,0,0,1,.87,1.3,27.18,27.18,0,0,0,2.76,3.38,24.5,24.5,0,0,0,5.22,4.14,24.16,24.16,0,0,0,7.91,3l-.21.41L168,174.07l-.17-.17.34-.39a55.81,55.81,0,0,0,21.73,10,58.85,58.85,0,0,0,7.22,1.11c.86.1,1.53.11,2,.16A3,3,0,0,1,199.8,184.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.71,171.91a.86.86,0,0,1-.24.11l-.71.26c-.62.23-1.57.52-2.74,1a87.47,87.47,0,0,0-55.91,67.57c-.24,1.24-.34,2.21-.45,2.87,0,.3-.09.55-.13.75a.83.83,0,0,1-.06.25s0-.09,0-.26,0-.45.07-.75c.09-.66.15-1.65.36-2.9a80.32,80.32,0,0,1,2.26-10.48,85.12,85.12,0,0,1,5.74-14.83,84.25,84.25,0,0,1,24.67-29.81,85.39,85.39,0,0,1,13.49-8.42,80.53,80.53,0,0,1,9.88-4.18c1.19-.44,2.14-.69,2.78-.89l.72-.21A.82.82,0,0,1,133.71,171.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.41,281.37a7.81,7.81,0,0,1-1-1c-.32-.33-.69-.75-1.1-1.26s-.9-1.07-1.36-1.75a39.46,39.46,0,0,1-3.05-4.92,43.91,43.91,0,0,1-2.74-6.53A44.63,44.63,0,0,1,77.56,259a40.13,40.13,0,0,1-.37-5.77c0-.82,0-1.57.09-2.22a16.09,16.09,0,0,1,.16-1.67,7.71,7.71,0,0,1,.24-1.4,7,7,0,0,1,0,1.42c0,.46-.07,1-.07,1.67s0,1.38,0,2.2a44,44,0,0,0,.48,5.7,48.79,48.79,0,0,0,1.59,6.82,47,47,0,0,0,2.67,6.47,42.06,42.06,0,0,0,2.93,4.92c.44.69.91,1.27,1.29,1.79s.73,1,1,1.31A7.6,7.6,0,0,1,88.41,281.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.68,290.75c-.05.13-1-.09-2-.79s-1.56-1.54-1.45-1.62.8.54,1.75,1.19S96.73,290.6,96.68,290.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.51,161.88a11.53,11.53,0,0,1-4-10.06,26.65,26.65,0,0,0,1.24,5.34A26,26,0,0,0,157.51,161.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M148.44,272.71c.6-1,1.21-2,1.82-3a1.87,1.87,0,0,0,.45,1.65,5,5,0,0,0,1.42,1.05c1,.56,2.32,1,3.34.46a2.9,2.9,0,0,0,1-3.14c-.19-.92-.61-1.79-.86-2.7a3.54,3.54,0,0,1,.18-2.75,4.4,4.4,0,0,1,2.74-1.59,34.1,34.1,0,0,1,11.92-1.27,21.28,21.28,0,0,1,11.13,4.17c-.27-1.43-1.54-2.43-2.79-3.18A22.34,22.34,0,0,0,161.44,260a19.85,19.85,0,0,0-12.94,11.64"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M151.15,267.41a8.05,8.05,0,0,0,2.62,4.36,1.68,1.68,0,0,0,1.74.5c.65-.33.67-1.25.55-2a16.35,16.35,0,0,0-2.28-5.95",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.75,267.41a8,8,0,0,1-2.61,4.36,1.7,1.7,0,0,1-1.75.5c-.65-.33-.67-1.25-.55-2a16.19,16.19,0,0,1,2.29-5.95",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.43,271.91c-.32.24-2.13-2-5.68-4.85A31.68,31.68,0,0,0,177,263a25.74,25.74,0,0,0-9.21-2.18,21.49,21.49,0,0,0-9.22,1.54,18.06,18.06,0,0,0-6.27,4.36c-3,3.26-3.54,6.22-3.95,6.11-.16,0-.25-.78,0-2.12a13.68,13.68,0,0,1,2.5-5.18,18.15,18.15,0,0,1,6.71-5.36,22,22,0,0,1,10.32-1.95,25.55,25.55,0,0,1,10.1,2.6,27.62,27.62,0,0,1,6.92,4.85C188.4,269,189.69,271.74,189.43,271.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M176.09,284.88c.16.3-.69,1.14-2.38,2a18.55,18.55,0,0,1-14.35.57c-1.75-.7-2.66-1.47-2.53-1.79.29-.69,4.46.6,9.66.35S175.74,284.21,176.09,284.88Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M129.83,211.21a121.09,121.09,0,0,0,76.8.67s-4.93,35.07-38.34,37S129.83,211.21,129.83,211.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.29,217.21a40.31,40.31,0,0,0,3.88,24,14.8,14.8,0,0,0,3.92,5.43,6.56,6.56,0,0,0,6.33,1.22c2-.83,3.28-2.86,4.2-4.85,4-8.69,4.42-15.78,4.84-25.35C171.12,219.55,163.36,219.2,155.29,217.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M201.67,230.44c.13.07-.29,1.23-1.4,3.15a33.5,33.5,0,0,1-6,7.3A41.47,41.47,0,0,1,189.2,245a42.81,42.81,0,0,1-6.64,3.56,37.85,37.85,0,0,1-33.51-1.59,43.24,43.24,0,0,1-6.27-4.18,41.11,41.11,0,0,1-4.71-4.54,33.17,33.17,0,0,1-5.22-7.83c-.93-2-1.24-3.21-1.1-3.27s.81,1,2,2.77a43.58,43.58,0,0,0,5.69,7.07,44.65,44.65,0,0,0,4.69,4.1,43.69,43.69,0,0,0,6.06,3.75,37.38,37.38,0,0,0,31.48,1.5,44.74,44.74,0,0,0,6.39-3.16,45.65,45.65,0,0,0,5.06-3.64,44.36,44.36,0,0,0,6.33-6.49C200.77,231.32,201.49,230.34,201.67,230.44Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M199.1,206a4.08,4.08,0,0,0-3,.65,52.58,52.58,0,0,1-29.76,5.1c-10.13-1.26-20.55-4.8-28.29-11.46-2.11,1.12-2.64,4.08-1.73,6.28s2.89,3.75,4.9,5a50.29,50.29,0,0,0,23.17,7.5,76.05,76.05,0,0,0,24.39-2.31c3.92-1,8-2.31,10.59-5.43a5.08,5.08,0,0,0,1.29-2.84A2.51,2.51,0,0,0,199.1,206Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M197.79,205.77c.38.53-2.22,3.4-7.75,6.21a41.74,41.74,0,0,1-10.25,3.56A44.32,44.32,0,0,1,153.46,213a42.37,42.37,0,0,1-9.4-5.43c-4.89-3.81-6.9-7.13-6.42-7.57s3.43,1.74,8.44,4.49a52.12,52.12,0,0,0,42.56,4.07C194.09,206.83,197.35,205.13,197.79,205.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.64,241.07s-.23-.2-.56-.63a16.74,16.74,0,0,1-1.26-1.9,24.2,24.2,0,0,1-2.73-7,24.52,24.52,0,0,1-.48-7.51,17.94,17.94,0,0,1,.35-2.26c.12-.52.2-.81.24-.8s-.13,1.18-.22,3.09a27.78,27.78,0,0,0,3.16,14.31C162,240.05,162.71,241,162.64,241.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.57,209.81a16,16,0,0,1-3.3,1.47c-1.09.43-2.42.95-4,1.44s-3.35,1.14-5.37,1.64-4.21,1.16-6.62,1.63c-1.2.25-2.43.55-3.72.77l-4,.66a126.61,126.61,0,0,1-17.89,1.36,128.6,128.6,0,0,1-17.89-1.3c-2.72-.46-5.32-.85-7.7-1.42-1.2-.27-2.36-.51-3.46-.78l-3.16-.86c-2-.52-3.8-1.15-5.37-1.66-.79-.27-1.52-.5-2.19-.74l-1.8-.72a15.58,15.58,0,0,1-3.29-1.49c.09-.26,4.91,1.55,12.93,3.54l3.15.75c1.1.25,2.26.45,3.45.69,2.37.52,4.94.84,7.64,1.27a144.23,144.23,0,0,0,17.69,1.16A137.88,137.88,0,0,0,187.38,216l3.94-.58c1.28-.19,2.51-.47,3.7-.69,2.39-.41,4.59-1,6.6-1.43s3.81-1,5.4-1.41,2.94-.83,4-1.17A15.86,15.86,0,0,1,214.57,209.81Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477,480.07c0,.14-102,.26-227.77.26s-227.78-.12-227.78-.26,102-.26,227.78-.26S477,479.93,477,480.07Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lightning--inject-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "198.7 153.57 193.28 129.18 206.2 127.85 210.4 106.08 212.27 132.97 199.15 134.28 198.7 153.57",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.02 156.78 214.38 139.32 222.9 144.69 235.86 133.42 224.15 150.71 215.52 145.23 206.02 156.78",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.7 153.57 193.28 129.18 206.2 127.85 210.4 106.08 212.27 132.97 199.15 134.28 198.7 153.57",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.02 156.78 214.38 139.32 222.9 144.69 235.86 133.42 224.15 150.71 215.52 145.23 206.02 156.78",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFound);
export default __webpack_public_path__ + "static/media/page-not-found.80846b1a74cf64bdfad8f04a9c61d5f1.svg";
export { ForwardRef as ReactComponent };